<template>
  <v-dialog :value="true" max-width="290">
    <v-card>
      <v-card-title class="headline">Editar Participante</v-card-title>
      <v-card-text class="pt-4">
        <v-alert type="error" v-if="errorMessage" class="mb-6">{{ errorMessage }}</v-alert>
        <v-form ref="form" @submit.prevent>
          <v-autocomplete
            v-if="!id && !celebrationId"
            label="Turma"
            v-model="fields.celebration_id.value"
            :rules="[...fields.celebration_id.rules, ...fields.celebration_id.apiErrors]"
            :items="fields.celebration_id.options"
            :loading="fields.celebration_id.loading"
            :search-input.sync="fields.celebration_id.search"
            placeholder="Comece escrevendo o nome da turma"
            hide-no-data no-filter
            outlined dense
          ></v-autocomplete>
          <v-autocomplete
            v-if="!id && !customerId"
            label="Cliente"
            v-model="fields.customer_id.value"
            :rules="[...fields.customer_id.rules, ...fields.customer_id.apiErrors]"
            :items="fields.customer_id.options"
            :loading="fields.customer_id.loading"
            :search-input.sync="fields.customer_id.search"
            placeholder="Comece escrevendo o nome do cliente"
            hide-no-data no-filter
            outlined dense
          ></v-autocomplete>
          <v-autocomplete
            label="Papel"
            v-model="fields.role.value"
            :rules="[...fields.role.rules, ...fields.role.apiErrors]"
            :items="fields.role.options"
            @input="fields.role.apiErrors = []"
            outlined dense
          ></v-autocomplete>
          <v-autocomplete
            label="Dia de pagamento"
            v-model="fields.payment_day.value"
            :rules="[...fields.payment_day.rules, ...fields.payment_day.apiErrors]"
            :items="payment_day_items"
            @input="fields.payment_day.apiErrors = []"
            outlined dense
          ></v-autocomplete>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="default" :disabled="saving" text @click="$emit('canceled')">
          Cancelar
        </v-btn>
        <v-btn color="success" :disabled="saving" :loading="saving" text @click="saveItem()">
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios'
import { mapMutations } from 'vuex'

export default {
  name: 'deleteModal',
  props: {
    item: {
      required: true,
      type: Object
    },
    id: {
      required: false,
      type: [String, Number]
    },
    celebrationId: {
      required: false,
      type: [String, Number]
    },
    customerId: {
      required: false,
      type: [String, Number]
    }
  },
  data: () => ({
    saving: false,
    fields: {
      celebration_id: {
        value: '',
        options: [],
        search: '',
        timeout: null,
        loading: false,
        rules: [
          v => !!v || 'A turma é obrigatória'
        ],
        apiErrors: []
      },
      customer_id: {
        value: '',
        options: [],
        search: '',
        timeout: null,
        loading: false,
        rules: [
          v => !!v || 'O cliente é obrigatório'
        ],
        apiErrors: []
      },
      role: {
        value: '',
        options: [
          { value: 'participant', text: 'Participante' },
          { value: 'organizer', text: 'Organizador' },
          { value: 'financial', text: 'Financeiro/Organizador' }
        ],
        rules: [
          v => !!v || 'O papel é obrigatório'
        ],
        apiErrors: []
      },
      payment_day: {
        value: 0,
        rules: [
          v => (!!v || v === 0) || 'O dia de pagamento é obrigatório'
        ],
        apiErrors: []
      }
    },
    errorMessage: null
  }),
  computed: {
    apiData () {
      let data = {}
      for (let key in this.fields) {
        if (key === 'payment_day' && this.fields[key].value >= 0) data[key] = this.fields[key].value
        else if (this.fields[key].value) data[key] = this.fields[key].value
      }
      return data
    },
    payment_day_items () {
      let items = [{ value: 0, text: 'Último dia' }]
      for (let i = 1; i <= 28; i++) items.push({ value: i, text: i })
      return items
    }
  },
  methods: {
    ...mapMutations(['SET_SNACKBAR']),
    generateApiErrors (apiErrors) {
      for (let key in apiErrors) {
        if (this.fields[key]) this.fields[key].apiErrors = apiErrors[key]
      }
    },
    getCelebrations () {
      if (this.fields.celebration_id.search) {
        this.fields.celebration_id.loading = true
        let endpoint = 'celebrations?&filter[q]=' + this.fields.celebration_id.search
        axios.get(endpoint)
          .then(response => {
            this.fields.celebration_id.options = response.data.data.map(e => ({
              value: e.id,
              text: e.name
            }))
          })
          .finally(() => (this.fields.celebration_id.loading = false))
      }
    },
    getCustomers () {
      if (this.fields.customer_id.search) {
        this.fields.customer_id.loading = true
        let endpoint = 'customers?&filter[q]=' + this.fields.customer_id.search
        axios.get(endpoint)
          .then(response => {
            this.fields.customer_id.options = response.data.data.map(e => ({
              value: e.id,
              text: e.name
            }))
          })
          .finally(() => (this.fields.customer_id.loading = false))
      }
    },
    saveItem () {
      let vue = this

      if (vue.$refs.form.validate()) {
        vue.saving = true
        vue.errorMessage = null
        const url = (vue.id) ? 'participants/' + vue.id : 'participants'
        const method = (vue.id) ? 'patch' : 'post'

        axios(url, {
          method,
          data: vue.apiData
        })
          .then(response => {
            if (response) {
              vue.saving = false
              vue.SET_SNACKBAR({ text: (vue.id) ? 'Participante atualizado' : 'Participante adicionado' })
              vue.$emit('edited')
            }
          })
          .catch(() => {
            vue.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido, por favor tente novamente' })
            vue.saving = false
            vue.$emit('error')
          })
      } else {
        vue.errorMessage = 'Verifique os campos com erro'
      }
    }
  },
  watch: {
    item: {
      handler (value) {
        let vue = this

        if (vue.item) {
          for (let key in vue.fields) {
            if (vue.item[key]) vue.fields[key].value = vue.item[key]
          }
        } else {
          vue.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido. Tente novamente.' })
          vue.$emit('error')
        }
      },
      deep: true
    },
    'fields.celebration_id.search' (val) {
      if (val) {
        if (this.fields.celebration_id.timeout) {
          clearTimeout(this.fields.celebration_id.timeout)
        }

        this.fields.celebration_id.timeout = setTimeout(() => {
          this.getCelebrations()
        }, 500)
      }
    },
    'fields.customer_id.search' (val) {
      if (!!val && val.split(' - ').length < 2) {
        if (this.fields.customer_id.timeout) {
          clearTimeout(this.fields.customer_id.timeout)
        }

        this.fields.customer_id.timeout = setTimeout(() => {
          this.getCustomers()
        }, 500)
      }
    }
  },
  created () {
    if (this.id) {
      let vue = this

      if (vue.item) {
        console.log(vue.item)
        for (let key in vue.fields) {
          if (key === 'customer_id' && vue.item.customer && vue.item.customer.id) vue.fields.customer_id.value = vue.item.customer.id
          else if (key === 'celebration_id' && vue.item.celebration && vue.item.celebration.id) vue.fields.celebration_id.value = vue.item.celebration.id
          else if (vue.item[key]) vue.fields[key].value = vue.item[key]
        }
      } else {
        vue.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido. Tente novamente.' })
        vue.$emit('error')
      }
    }

    if (this.celebrationId) {
      this.fields.celebration_id.value = this.celebrationId
    }

    if (this.customerId) {
      this.fields.customer_id.value = this.customerId
    }
  }
}
</script>
